import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.querySelectorAll('.js-references-logos').forEach((carousel) => {
  new Splide(carousel, {
    type: 'loop',
    drag: false,
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: 90,
    breakpoints: {
      1023: {
        gap: 60,
      },
    },
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  }).mount({ AutoScroll });
});
